import { withTranslation } from 'react-i18next';
import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { connect } from 'react-redux';

import { CountryListItem, CurrencyListItem } from '@manigo/manigo-domain-typings';
import withAccessControl from 'hoc/withAccessControl';
import { RootState } from 'store/rootReducer';
import { getStandardListData } from 'store/standardLists.helpers';
import { currenciesListsPerLocationStoreKeyName, currenciesReducerName } from 'store/currencies/reducer';
import { countriesListsPerLocationStoreKeyName, countriesReducerName } from 'store/countries/reducer';
import { authorisationReducerName } from 'store/authorisation/reducer';

import { localesReducerName } from 'store/locales/reducer';
import { AppLoadingPlaceholderOwnProps, AppLoadingPlaceholderStateProps } from './AppLoadingPlaceholder.types';
import AppLoadingPlaceholder from './AppLoadingPlaceholder.layout';


const mapStateToProps = (state: RootState): AppLoadingPlaceholderStateProps => ({
    currencies: getStandardListData<CurrencyListItem>({
        state,
        reducerName: currenciesReducerName,
        listsByLocationStoreKeyName: currenciesListsPerLocationStoreKeyName,
        useGlobalLocation: true,
    })?.items,
    countries: getStandardListData<CountryListItem>({
        state,
        reducerName: countriesReducerName,
        listsByLocationStoreKeyName: countriesListsPerLocationStoreKeyName,
        useGlobalLocation: true,
    })?.items,
    isI18nReady: state[localesReducerName].isI18nReady,
    isRefreshingSession: state[authorisationReducerName].isRefreshingSession,
});


const decorate = compose<ComponentType<AppLoadingPlaceholderOwnProps>>(
    withTranslation('common'),
    withAccessControl,
    connect(mapStateToProps),
);


export default decorate(AppLoadingPlaceholder);
